import React from 'react'

import FieldLabel from '@react/react-spectrum/FieldLabel'
import Rating from '@react/react-spectrum/Rating'
import Switch from '@react/react-spectrum/Switch'
import Textfield from '@react/react-spectrum/Textfield'

import FieldInfo from 'components/FieldInfo'
import MediaUpload from 'components/MediaUpload'
import PriceField from 'components/PriceField'

import { AdobeExperiencePlatform } from 'components/Icons'
import { RichTextFormField } from 'components/RichTextEditor'
import { ScreenPicker } from '../../ScreenPicker'
import Multifield from 'components/Multifield'

const Product = ({ screen, project, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='Summary'>
        <RichTextFormField
          label='Page Summary'
          value={content.subtitle || ''}
          onChange={onChange('subtitle')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Name' labelFor='product-name'>
        <FieldInfo title='AEP data' icon={<AdobeExperiencePlatform size='XS' />}>
          This field is used as a value for Product-related Experience Events in AEP
        </FieldInfo>
        <Textfield
          id='product-name'
          placeholder='Name'
          name='name'
          value={content.name || ''}
          onChange={onChange('name')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Category'>
        <ScreenPicker
          screenName={screen?.meta?.name}
          value={content.category || ''}
          onChange={onChange('category')}
          filter={(screen) => ['CategoryPage', 'BlogPage'].includes(screen.template)}
          disabled={disabled}
        />
      </FieldLabel>

      <Switch label='Showroom View' checked={content.advanced} onChange={(v) => !disabled && onChange('advanced')(v)} />

      {content.advanced && (
        <FieldLabel label='Images'>
          <Multifield value={content.images} onChange={onChange('images')} disabled={disabled} />
        </FieldLabel>
      )}

      {!content.advanced && (
        <>
          <FieldLabel label='Image' labelFor='image'>
            <MediaUpload
              type='image'
              value={content.image || ''}
              maxHeight='100px'
              onUpload={onChange('image')}
              projectId={project?.meta?.id}
              path={`product-${screen?.meta?.name}-image`}
              withTextfield={true}
              disabled={disabled}
            />
          </FieldLabel>
          <FieldLabel label='Price'>
            <PriceField
              placeholder='Price'
              name='price'
              value={content.price || null}
              onChange={onChange('price')}
              disabled={disabled}
            />
          </FieldLabel>

          <FieldLabel label='Button Label' labelFor='product-button-label'>
            <Textfield
              id='product-button-label'
              placeholder={'Add to Cart'}
              name='buttonLabel'
              value={content.buttonLabel || ''}
              onChange={onChange('buttonLabel')}
              disabled={disabled}
            />
          </FieldLabel>
        </>
      )}

      <FieldLabel label='Description'>
        <RichTextFormField
          label={'Short description'}
          value={content.description || ''}
          onChange={onChange('description')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Full Description'>
        <RichTextFormField
          label={'Full Description'}
          value={content.fullDescription || ''}
          onChange={onChange('fullDescription')}
          disabled={disabled}
        />
      </FieldLabel>

      <Switch
        label='Show&nbsp;Availability'
        checked={!!content.showAvailability}
        onChange={(v) => !disabled && onChange('showAvailability')(v)}
      />

      <Switch
        label='Display&nbsp;Breadcrumb'
        checked={!!content.displayBreadcrumb}
        onChange={(v) => !disabled && onChange('displayBreadcrumb')(v)}
      />

      <Switch
        label='Display&nbsp;Rating'
        checked={!!content.displayRating}
        onChange={(v) => !disabled && onChange('displayRating')(v)}
      />

      <FieldLabel label='Rating'>
        <Rating value={content.rating || 0} onChange={onChange('rating')} disabled={disabled} />
      </FieldLabel>
    </>
  )
}

const Actions = ({ screen, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='Primary Action Label' labelFor='product-primary-action-label'>
        <Textfield
          id='product-primary-action-label'
          placeholder={''}
          name='actionButtonLabel'
          value={content.actionButtonLabel || ''}
          onChange={onChange('actionButtonLabel')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Primary Action Link'>
        <ScreenPicker
          screenName={screen?.meta?.name}
          value={content.actionButtonLink || ''}
          onChange={onChange('actionButtonLink')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Secondary Action Label' labelFor='product-secondary-action-label'>
        <Textfield
          id='product-secondary-action-label'
          placeholder={''}
          name='secondaryActionButtonLabel'
          value={content.secondaryActionButtonLabel || ''}
          onChange={onChange('secondaryActionButtonLabel')}
          disabled={disabled}
        />
      </FieldLabel>
    </>
  )
}

export default [
  { label: 'Product', content: Product },
  { label: 'Actions on category page', content: Actions },
]
